import {
    ClinicFieldsFragment,
    NotificationTemplateFieldsFragment,
    useQueryNotificationTemplatesQuery,
} from '~graphql/generated/graphql'
import { eqBoolFilter, eqStringFilter } from '~utils/query-helpers'
import { constructOrderBy } from '~utils/querying'

export function useNotificationTemplateValues(
    clinic: ClinicFieldsFragment,
    hideInactiveNotifications: boolean,
): NotificationTemplateValues {
    const { data, loading } = useQueryNotificationTemplatesQuery({
        variables: {
            where: [
                eqStringFilter('clinic', clinic.id),
                ...(hideInactiveNotifications
                    ? [
                          eqBoolFilter('is_active', true),
                          eqBoolFilter('is_archived', false),
                      ]
                    : []),
            ],
            pageSize: 1000,
            orderBy: constructOrderBy('name', true),
        },
    })

    return {
        notificationTemplatesLoading: loading,
        notificationTemplates: data?.queryNotificationTemplates || [],
    }
}

export type NotificationTemplateValues = {
    notificationTemplatesLoading: boolean
    notificationTemplates: NotificationTemplateFieldsFragment[]
}
